export default "__VITE_ASSET__BVHHuczy__"